import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getFriendsPageInfos, getFriendSuggestions } from "../../../functions/user";
import "./style.css";

export default function LeftHome({ user }) {
  const { user: currentUser } = useSelector((state) => ({ ...state }));
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [sLoading, setSLoading] = useState(true);
  const [sError, setSError] = useState("");
  


  const loadFriends = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getFriendsPageInfos(currentUser.token);
      if (response.status === "ok") {
        setFriends(response.data.friends || []);
      } else {
        setError("Failed to load friends");
      }
    } catch (err) {
      setError("Error loading friends");
    } finally {
      setLoading(false);
    }
  }, [currentUser.token]);

  const loadSuggestions = useCallback(async () => {
    try {
      setSLoading(true);
      const res = await getFriendSuggestions(currentUser.token);
      if (res.status === "ok") {
        // backend returns { suggestions: [...] }
        setSuggestions(res.data?.suggestions || []);
      } else {
        setSError("Failed to load suggestions");
      }
    } catch (e) {
      setSError("Error loading suggestions");
    } finally {
      setSLoading(false);
    }
  }, [currentUser.token]);

  useEffect(() => {
    loadFriends();
    loadSuggestions();
  }, [loadFriends, loadSuggestions]);

  

  return (
    <div className="left_home">
      <div className="left_home_content scrollbar">
        {/* Friends Section */}
        <div className="friends_section">
          <div className="friends_header">
            <h3 className="friends_list_title">Friends</h3>
            <Link to="/friends/all" className="see_all_link">
              See all
            </Link>
          </div>

          {loading && (
            <div className="loading_text">Loading friends...</div>
          )}

          {error && (
            <div className="error_text">{error}</div>
          )}

          {!loading && !error && friends.length === 0 && (
            <div className="no_friends">
              <p>No friends to show</p>
              <Link to="/friends/suggestions" className="find_friends_btn">
                Find friends
              </Link>
            </div>
          )}

          {!loading && !error && friends.length > 0 && (
            <>
              <div className={`friends_list_container friends-count-${Math.min(friends.length, 6)}`}>
                {friends.slice(0, 6).map((friend) => {
                  const displayName = (friend.name?.trim() || `${friend.first_name || ""} ${friend.last_name || ""}`.trim() || friend.username || "Unknown");
                  return (
                    <Link
                      key={friend._id}
                      to={`/profile/${friend.username || friend._id}`}
                      className="friend_item friend_card"
                      aria-label={`Open profile of ${displayName}`}
                    >
                      <div className="friend_thumb">
                        <img src={friend.picture} alt="" className="friend_picture" />
                        <span className="friend_name_overlay">{displayName}</span>
                      </div>
                    </Link>
                  );
                })}
              </div>

              {friends.length > 6 && (
                <Link to="/friends/all" className="see_more_friends">
                  <div className="see_more_item">
                    {/* <div className="see_more_icon">+</div>
                    <span>See {friends.length - 6} more friends</span> */}
                  </div>
                </Link>
              )}
            </>
          )}
        </div>
        {/* Suggested Friends Section */}
        <div className="friends_section suggested_friends" style={{ marginTop: 12 }}>
          <div className="friends_header">
            <h3 className="friends_list_title">Suggested Friends</h3>
            <Link to="/friends/suggestions" className="see_all_link">
              See all
            </Link>
          </div>

          {sLoading && (
            <div className="loading_text">Loading suggestions...</div>
          )}

          {sError && <div className="error_text">{sError}</div>}

          {!sLoading && !sError && suggestions.length === 0 && (
            <div className="no_friends">
              <p>No suggestions right now</p>
            </div>
          )}

          {!sLoading && !sError && suggestions.length > 0 && (
            <>
              <div className="friends_list_container suggested_friends_list">
                {suggestions.slice(0, 6).map((u) => {
                  const name = (u.name?.trim() || [u.first_name, u.last_name].filter(Boolean).join(" ") || u.username || "Unknown");
                  // Remove `friend_card` here so suggested items follow the small-avatar styles
                  // defined for `.left_home .suggested_friends_list .friend_picture`.
                  return (
                    <div key={u._id} className="friend_item suggest_item" style={{ gap: 8 }}>
                      <div className="friend_thumb">
                        <Link to={`/profile/${u.username || u._id}`} aria-label={`Open profile of ${name}`}>
                          <img src={u.picture} alt="" className="friend_picture" />
                          <span className="friend_name_overlay">{name}</span>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>

              {suggestions.length > 6 && (
                <Link to="/friends/suggestions" className="see_more_friends">
                  <div className="see_more_item">
                    {/* <div className="see_more_icon">+</div> */}
                    {/* <span>See {suggestions.length - 6} more suggestions</span> */}
                  </div>
                </Link>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
